<template>
  <app-navigation
    title="Registro de estudantes">
    <load-form-handler
      placeholder
      placeholderMessage="Não foi possível buscar pelos estudantes"
      :promise="getStudents"
      v-model="students">
      <v-layout justify-center row wrap mt-2>
        <student-card
          v-for="student in students"
          :key="student.id"
          :student="student"
          @click="navigateToForms"
          button_label="abrir registro"
        />
      </v-layout>
    </load-form-handler>
  </app-navigation>
</template>

<script>
import AppNavigation from '@/layouts/AppNavigation'
import StudentCard from '@/components/StudentCard'
import LoadFormHandler from '@/components/LoadFormHandler'
import * as api from '@/api'
/**
 * @group Tabs
 * Componente para listagem de alunos
 */
export default {
  name: 'StudentRegistration',

  data: () => ({
    students: []
  }),

  components: {
    AppNavigation,
    StudentCard,
    LoadFormHandler
  },

  methods: {
    getStudents () {
      return api.students.getStudents()
    },

    navigateToForms (studentId) {
      this.$router.push({ name: 'student_register_tabs', params: { id: studentId } })
    }
  }
}
</script>
